/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { EnumValueOfStatusRecordType } from '../models/enum-value-of-status-record-type';
import { EnumValueOfImportanceStatus } from '../models/enum-value-of-importance-status';
import { EnumValueOfEventType } from '../models/enum-value-of-event-type';
import { EnumValueOfStageType } from '../models/enum-value-of-stage-type';
import { EnumValueOfFormType } from '../models/enum-value-of-form-type';
import { EnumValueOfApproverStatus } from '../models/enum-value-of-approver-status';
import { EnumValueOfProcessStatus } from '../models/enum-value-of-process-status';
import { EnumValueOfJobType } from '../models/enum-value-of-job-type';
import { EnumValueOfFrequencyType } from '../models/enum-value-of-frequency-type';
import { EnumValueOfRoleType } from '../models/enum-value-of-role-type';
@Injectable({
  providedIn: 'root',
})
class ConstantsService extends __BaseService {
  static readonly ConstantsGetAllSafetyConsultantDefectRecordTypesPath = '/Constants/GetAllSafetyConsultantDefectRecordTypes';
  static readonly ConstantsGetAllImportanceStatusesPath = '/Constants/GetAllImportanceStatuses';
  static readonly ConstantsGetAllEventTypesPath = '/Constants/GetAllEventTypes';
  static readonly ConstantsGetAllStageTypesPath = '/Constants/GetAllStageTypes';
  static readonly ConstantsGetAllFormTypesPath = '/Constants/GetAllFormTypes';
  static readonly ConstantsGetAllApproverStatusesPath = '/Constants/GetAllApproverStatuses';
  static readonly ConstantsGetAllProcessStatusesPath = '/Constants/GetAllProcessStatuses';
  static readonly ConstantsGetAllJobTypesPath = '/Constants/GetAllJobTypes';
  static readonly ConstantsGetAllFrequencyTypesPath = '/Constants/GetAllFrequencyTypes';
  static readonly ConstantsGetAllRolesTypesPath = '/Constants/GetAllRolesTypes';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ConstantsGetAllSafetyConsultantDefectRecordTypesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfStatusRecordType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllSafetyConsultantDefectRecordTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfStatusRecordType>>;
      })
    );
  }  ConstantsGetAllSafetyConsultantDefectRecordTypes(): __Observable<Array<EnumValueOfStatusRecordType>> {
    return this.ConstantsGetAllSafetyConsultantDefectRecordTypesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfStatusRecordType>)
    );
  }
  ConstantsGetAllImportanceStatusesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfImportanceStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllImportanceStatuses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfImportanceStatus>>;
      })
    );
  }  ConstantsGetAllImportanceStatuses(): __Observable<Array<EnumValueOfImportanceStatus>> {
    return this.ConstantsGetAllImportanceStatusesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfImportanceStatus>)
    );
  }
  ConstantsGetAllEventTypesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfEventType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllEventTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfEventType>>;
      })
    );
  }  ConstantsGetAllEventTypes(): __Observable<Array<EnumValueOfEventType>> {
    return this.ConstantsGetAllEventTypesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfEventType>)
    );
  }
  ConstantsGetAllStageTypesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfStageType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllStageTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfStageType>>;
      })
    );
  }  ConstantsGetAllStageTypes(): __Observable<Array<EnumValueOfStageType>> {
    return this.ConstantsGetAllStageTypesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfStageType>)
    );
  }
  ConstantsGetAllFormTypesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfFormType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllFormTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfFormType>>;
      })
    );
  }  ConstantsGetAllFormTypes(): __Observable<Array<EnumValueOfFormType>> {
    return this.ConstantsGetAllFormTypesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfFormType>)
    );
  }
  ConstantsGetAllApproverStatusesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfApproverStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllApproverStatuses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfApproverStatus>>;
      })
    );
  }  ConstantsGetAllApproverStatuses(): __Observable<Array<EnumValueOfApproverStatus>> {
    return this.ConstantsGetAllApproverStatusesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfApproverStatus>)
    );
  }
  ConstantsGetAllProcessStatusesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfProcessStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllProcessStatuses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfProcessStatus>>;
      })
    );
  }  ConstantsGetAllProcessStatuses(): __Observable<Array<EnumValueOfProcessStatus>> {
    return this.ConstantsGetAllProcessStatusesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfProcessStatus>)
    );
  }
  ConstantsGetAllJobTypesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfJobType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllJobTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfJobType>>;
      })
    );
  }  ConstantsGetAllJobTypes(): __Observable<Array<EnumValueOfJobType>> {
    return this.ConstantsGetAllJobTypesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfJobType>)
    );
  }
  ConstantsGetAllFrequencyTypesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfFrequencyType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllFrequencyTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfFrequencyType>>;
      })
    );
  }  ConstantsGetAllFrequencyTypes(): __Observable<Array<EnumValueOfFrequencyType>> {
    return this.ConstantsGetAllFrequencyTypesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfFrequencyType>)
    );
  }
  ConstantsGetAllRolesTypesResponse(): __Observable<__StrictHttpResponse<Array<EnumValueOfRoleType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Constants/GetAllRolesTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EnumValueOfRoleType>>;
      })
    );
  }  ConstantsGetAllRolesTypes(): __Observable<Array<EnumValueOfRoleType>> {
    return this.ConstantsGetAllRolesTypesResponse().pipe(
      __map(_r => _r.body as Array<EnumValueOfRoleType>)
    );
  }
}

module ConstantsService {
}

export { ConstantsService }
